"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcFabMenuBehavior = void 0;
var helpers_1 = require("../../../common/helpers");
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_fabmenu_constans_1 = require("./bc-fabmenu-constans");
var BcFabMenuBehavior = (function (_super) {
    __extends(BcFabMenuBehavior, _super);
    function BcFabMenuBehavior() {
        var _this = _super.call(this) || this;
        _this.selectionCallback = null;
        return _this;
    }
    BcFabMenuBehavior.prototype.initFabMenu = function (configFabMenu) {
        this.configFabMenu = configFabMenu;
        this.configFaMenuButtonOpen();
        this.createActionsListItems();
    };
    BcFabMenuBehavior.prototype.configFaMenuButtonOpen = function () {
        this.mySelf.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, "".concat(common_constants_1.BcCommonConstants.TRUE));
        var fabMenuButtonOpen = this.createFabButtonElement();
        this.mySelf.appendChild(fabMenuButtonOpen);
        var iconButton = fabMenuButtonOpen.querySelector("i.".concat(bc_fabmenu_constans_1.BcFabMenuConstants.BC_ICON));
        iconButton.textContent = this.configFabMenu.openIcon;
        this.addEventListenerOpenButton(fabMenuButtonOpen);
        this.addEventListenerBackDrop();
    };
    BcFabMenuBehavior.prototype.addEventListenerOpenButton = function (fabMenuButtonOpen) {
        var _this = this;
        fabMenuButtonOpen.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.openAndCloseFabmenu();
        });
        document.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                if (fabMenuButtonOpen.classList.contains(bc_fabmenu_constans_1.BcFabMenuConstants.BC_ICON_BUTTON_SELECTED)) {
                    _this.openAndCloseFabmenu();
                }
            }
        });
    };
    BcFabMenuBehavior.prototype.openAndCloseFabmenu = function () {
        this.mySelf.classList.toggle(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_ACTIVE);
        var fabMenuButtonOpen = this.mySelf.querySelector("#".concat(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_BUTTON));
        var backdrop = this.mySelf.querySelector(".".concat(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_BACKDROP));
        document.body.classList.toggle(bc_fabmenu_constans_1.BcFabMenuConstants.NO_SCROLL);
        fabMenuButtonOpen.classList.toggle(bc_fabmenu_constans_1.BcFabMenuConstants.BC_ICON_BUTTON_SELECTED);
        if (this.configFabMenu.backdrop) {
            backdrop.classList.toggle(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_BACKDROP_ACTIVE);
        }
        this.setAttributesToOpenAndCloseButton(fabMenuButtonOpen);
        this.showActionItems();
    };
    BcFabMenuBehavior.prototype.setAttributesToOpenAndCloseButton = function (fabMenuButtonOpen) {
        if (fabMenuButtonOpen.classList.contains(bc_fabmenu_constans_1.BcFabMenuConstants.BC_ICON_BUTTON_SELECTED)) {
            fabMenuButtonOpen.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, "".concat(common_constants_1.BcCommonConstants.TRUE));
            fabMenuButtonOpen.setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, "".concat(common_constants_1.BcCommonConstants.TRUE));
            fabMenuButtonOpen.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, this.configFabMenu.nameCloseButton === ''
                ? this.configFabMenu.nameOpenButton
                : this.configFabMenu.nameCloseButton);
            this.setFocusFirsElement();
        }
        else {
            fabMenuButtonOpen.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, "".concat(common_constants_1.BcCommonConstants.FALSE));
            fabMenuButtonOpen.setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, "".concat(common_constants_1.BcCommonConstants.FALSE));
            fabMenuButtonOpen.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, this.configFabMenu.nameOpenButton);
            fabMenuButtonOpen.setAttribute(common_constants_1.BcCommonConstants.TABINDEX, "".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.N0));
        }
    };
    BcFabMenuBehavior.prototype.setFocusFirsElement = function () {
        var fabMenuButtonOpen = this.mySelf.querySelector("#".concat(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_BUTTON));
        var actionButtons = this.mySelf.querySelectorAll(".".concat(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_ACTIONS_BUTTON, " li"));
        var firstElement = actionButtons[0];
        var lastElement = actionButtons[actionButtons.length - 1];
        fabMenuButtonOpen.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.EVENT_TAP &&
                fabMenuButtonOpen.classList.contains(bc_fabmenu_constans_1.BcFabMenuConstants.BC_ICON_BUTTON_SELECTED)) {
                event.preventDefault();
                firstElement.focus();
            }
            if (event.key === common_constants_1.BcCommonConstants.EVENT_TAP &&
                event.shiftKey &&
                fabMenuButtonOpen.classList.contains(bc_fabmenu_constans_1.BcFabMenuConstants.BC_ICON_BUTTON_SELECTED)) {
                event.preventDefault();
                lastElement.focus();
            }
        });
    };
    BcFabMenuBehavior.prototype.addEventListenerBackDrop = function () {
        var _this = this;
        var backdrop = this.mySelf.querySelector(".".concat(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_BACKDROP));
        backdrop.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            if (backdrop.classList.contains(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_BACKDROP_ACTIVE)) {
                _this.openAndCloseFabmenu();
            }
        });
    };
    BcFabMenuBehavior.prototype.createActionsListItems = function () {
        var _this = this;
        var ulElement = this.mySelf.querySelector(".".concat(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_ACTIONS_BUTTON));
        var items = this.configFabMenu.actionItems;
        items.slice(common_constants_1.COMMON_CONSTANTS_NUMBERS.N0, common_constants_1.COMMON_CONSTANTS_NUMBERS.N6).forEach(function (item, index) {
            var iElement = _this.createIelement(item.icon);
            var iconButton = _this.createIconButton();
            var spanElement = _this.createSpanElement(item);
            var liElement = _this.createLiElement(item, index, items.length);
            liElement.appendChild(spanElement);
            liElement.appendChild(iconButton);
            iconButton.appendChild(iElement);
            ulElement.appendChild(liElement);
            _this.setAddLEventListenerLiElements(liElement);
        });
    };
    BcFabMenuBehavior.prototype.createIelement = function (icon) {
        var _a;
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.I_TAG,
            classList: [common_constants_1.BcCommonConstants.ICONS_CLASS],
            innerText: icon,
            props: (_a = {},
                _a[common_constants_1.BcCommonConstants.ARIA_HIDDEN] = ["".concat(common_constants_1.BcCommonConstants.TRUE)],
                _a),
        });
    };
    BcFabMenuBehavior.prototype.createIconButton = function () {
        var _a;
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.BUTTON_TAG,
            classList: [
                common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG,
                "".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG, "-solid"),
                "".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG, "-white"),
                "".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG, "-medium"),
            ],
            props: (_a = {},
                _a[common_constants_1.BcCommonConstants.TABINDEX] = ["".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.Netative1)],
                _a[common_constants_1.BcCommonConstants.ARIA_HIDDEN] = ["".concat(common_constants_1.BcCommonConstants.TRUE)],
                _a),
        });
    };
    BcFabMenuBehavior.prototype.createSpanElement = function (item) {
        var _a;
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.SPAN_TAG,
            classList: [bc_fabmenu_constans_1.BcFabMenuConstants.BC_ACTION_TEXT],
            innerText: item.text,
            props: (_a = {},
                _a[common_constants_1.BcCommonConstants.ARIA_HIDDEN] = ["".concat(common_constants_1.BcCommonConstants.TRUE)],
                _a),
        });
    };
    BcFabMenuBehavior.prototype.createLiElement = function (item, index, totalItems) {
        var _a;
        var amountItems = totalItems > common_constants_1.COMMON_CONSTANTS_NUMBERS.N6 ? common_constants_1.COMMON_CONSTANTS_NUMBERS.N6 : totalItems;
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.LI_TAG,
            props: (_a = {},
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = ["".concat(item.text)],
                _a[common_constants_1.BcCommonConstants.ROLE] = ["".concat(common_constants_1.BcCommonConstants.MENU_ITEM_TAG)],
                _a[common_constants_1.BcCommonConstants.ARIA_POSINSET] = [index + 1],
                _a[common_constants_1.BcCommonConstants.ARIA_SETSIZE] = [amountItems],
                _a[common_constants_1.BcCommonConstants.ARIA_SELECTED] = ["".concat(common_constants_1.BcCommonConstants.FALSE)],
                _a),
        });
    };
    BcFabMenuBehavior.prototype.createFabButtonElement = function () {
        var _a;
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.BUTTON_TAG,
            classList: [
                common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG,
                "".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG, "-fab"),
                "".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG, "-white"),
                "".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG, "-medium"),
            ],
            props: (_a = {},
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = ["".concat(this.configFabMenu.nameOpenButton)],
                _a[common_constants_1.BcCommonConstants.ROLE] = ["".concat(common_constants_1.BcCommonConstants.BUTTON_TAG)],
                _a[common_constants_1.BcCommonConstants.ARIA_SELECTED] = ["".concat(common_constants_1.BcCommonConstants.FALSE)],
                _a[common_constants_1.BcCommonConstants.TABINDEX] = ["".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.N0)],
                _a[common_constants_1.BcCommonConstants.ID] = ["".concat(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_BUTTON)],
                _a),
            children: [this.createIelement(this.configFabMenu.openIcon)],
        });
    };
    BcFabMenuBehavior.prototype.setAddLEventListenerLiElements = function (liElement) {
        var _this = this;
        liElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                var actionButtons = _this.mySelf.querySelectorAll(".".concat(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_ACTIONS_BUTTON, " li"));
                actionButtons.forEach(function (item) {
                    return item.setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, "".concat(common_constants_1.BcCommonConstants.FALSE));
                });
                liElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, "".concat(common_constants_1.BcCommonConstants.TRUE));
                _this.setSelectedItem(liElement);
            }
        });
        liElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            var actionButtons = _this.mySelf.querySelectorAll(".".concat(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_ACTIONS_BUTTON, " li"));
            actionButtons.forEach(function (item) { return item.setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, "".concat(common_constants_1.BcCommonConstants.FALSE)); });
            liElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, "".concat(common_constants_1.BcCommonConstants.TRUE));
            _this.setSelectedItem(liElement);
        });
    };
    BcFabMenuBehavior.prototype.setSelectedItem = function (item) {
        var position = parseInt(item.getAttribute(common_constants_1.BcCommonConstants.ARIA_POSINSET));
        if (this.selectionCallback) {
            this.selectionCallback(position);
        }
    };
    BcFabMenuBehavior.prototype.showActionItems = function () {
        var ulElement = this.mySelf.querySelector(".".concat(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_ACTIONS_BUTTON));
        ulElement.classList.toggle(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_ACTIONS_BUTTON_ACTIVE);
        this.setAttributeTabIndex();
    };
    BcFabMenuBehavior.prototype.setAttributeTabIndex = function () {
        var fabMenuButtonOpen = this.mySelf.querySelector("#".concat(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_BUTTON));
        var actionButtons = this.mySelf.querySelectorAll(".".concat(bc_fabmenu_constans_1.BcFabMenuConstants.BC_FAB_MENU_ACTIONS_BUTTON, " li"));
        if (fabMenuButtonOpen.classList.contains(bc_fabmenu_constans_1.BcFabMenuConstants.BC_ICON_BUTTON_SELECTED)) {
            actionButtons.forEach(function (li) {
                li.setAttribute(common_constants_1.BcCommonConstants.TABINDEX, "".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.N0));
            });
        }
        else {
            actionButtons.forEach(function (li) {
                li.setAttribute(common_constants_1.BcCommonConstants.TABINDEX, "".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.Netative1));
            });
        }
    };
    BcFabMenuBehavior.prototype.onSelection = function (callback) {
        this.selectionCallback = callback;
    };
    return BcFabMenuBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcFabMenuBehavior = BcFabMenuBehavior;
